import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { BrowserRouter as Router } from 'react-router-dom';
const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

// Verify SDK script has loaded (browser guarantees regular scripts execute before module scripts)
if (!window.ScLoan) {
  console.error(
    'ScLoan SDK is not available. Make sure the SDK script tag is present in index.html before the module script.',
  );
}

createRoot(root).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
